import React from 'react'
import CountUp from 'react-countup'

const Counter = () => {
    return (
        <>
            <section className='my-5'>
                <div className='container px-lg-5 px-md-5 px-4'>

                    <div className='row counter-bg py-4'>

                        <div className='col-lg-3 col-md-6 col-6 my-3 d-flex'>
                            <i className="fa-solid counter-icon me-3 fa-tags"></i>
                            <div>
                                <CountUp end={9} duration={2} enableScrollSpy={true} className='counter-num' /><span className='fs-4'>+</span>
                                <p className='counter-text'>Years of Existence</p></div>
                        </div>

                        <div className='col-lg-3 col-md-6 col-6 my-3 d-flex'>
                            <i className="fa-solid counter-icon me-3 fa-hand-holding-dollar"></i>
                            <div>
                                <CountUp end={500} duration={2} enableScrollSpy={true} className='counter-num' /><span className='fs-4'>k</span>
                                <p className='counter-text'>Donations</p></div>
                        </div>

                        <div className='col-lg-3 col-md-6 col-6 my-3 d-flex'>
                            <i className="fa-solid counter-icon me-3 fa-calendar-day"></i>
                            <div>
                                <CountUp end={12} duration={2} enableScrollSpy={true} className='counter-num' /><span className='fs-4'>+</span>
                                <p className='counter-text'>Development Program</p></div>
                        </div>

                        <div className='col-lg-3 col-md-6 col-6 my-3 d-flex'>
                            <i className="fa-solid counter-icon me-3 fa-handshake"></i>
                            <div>
                                <CountUp end={2} duration={2} enableScrollSpy={true} className='counter-num' /><span className='fs-4'>k</span>
                                <p className='counter-text'>Helped People</p></div>
                        </div>

                    </div>
                    {/* row ends */}

                </div>
            </section>
        </>
    )
}

export default Counter
